(function(){
  'use strict';
  function init(){
    var context=document.getElementById('cs-themed-context');
    var family=context?context.dataset.family:location.pathname.split('/products/')[1];
    var theme=context?context.dataset.theme:new URLSearchParams(location.search).get('theme');
    if(!['cupcakes','cookies','personalised-complete-party-platter'].includes(family))return;
    var cup=family==='cupcakes',platter=family==='personalised-complete-party-platter';
    var root=document.getElementById(cup?'cs-cupcake-pdp':'cs-topper-extra-pdp');
    var form=document.getElementById(cup?'cupcake-product-form':'extra-product-form');
    if(!root||!form)return;
    var selector=form.querySelector('select[name="id"]'),button=form.querySelector('button[type="submit"]');
    if(!selector||!button)return;
    var options=Array.from(selector.options);
    options.filter(function(o){return / — (Chocolate Mud|White Chocolate Mud|Personalised topper)/.test(o.textContent)}).forEach(function(o){o.hidden=true});
    if(context){
      var style=document.createElement('style');
      style.textContent='#cs-cupcake-pdp #cupcake-disc-details .sp-personal-grid,#cs-topper-extra-pdp #extra-topper-details .sp-personal-grid{display:grid!important}#cs-topper-extra-pdp #extra-topper-details .sp-topper-wording{display:block!important}';
      document.head.appendChild(style);
    }
    function sync(){
      var disc=root.querySelector('input[name="'+(cup?'cupcake-disc':'extra-topper')+'"]:checked');
      if(context&&theme!=='Customise Your Cake'&&!cup&&disc){
        var message=document.getElementById('extra-topper-message');
        if(message){var label=message.closest('label');if(label){if(label.parentElement.classList.contains('sp-artwork-choice'))document.getElementById('extra-topper-details').appendChild(label);label.hidden=disc.value!=='add'}}
        root.querySelectorAll('.sp-upload-note input[type="file"]').forEach(function(file){file.required=false;file.disabled=true});
        var art=document.getElementById('extra-prop-artwork');if(art)art.disabled=true;
      }
      if(cup){
        var flavour=root.querySelector('input[name="cupcake-flavour"]:checked');
        var mud=flavour&&/Mud/.test(flavour.value);
        var boxes=Number(document.getElementById('cupcake-form-boxes')?.value||1);
        var total=(130+(mud?15:0))*boxes;
        var price=document.getElementById('cupcake-live-price');if(price)price.textContent='$'+total.toLocaleString('en-AU');
        var summary=document.getElementById('cupcake-box-summary');if(summary)summary.textContent=boxes+' '+(boxes===1?'box':'boxes')+' · '+boxes*12+' cupcakes · $'+total.toLocaleString('en-AU');
        button.textContent='Add '+boxes+' '+(boxes===1?'box':'boxes')+' of cupcakes · $'+total.toLocaleString('en-AU');
      }else if(platter){
        var add=disc&&disc.value==='add';
        var price=document.getElementById('extra-live-price');if(price)price.textContent=add?'$600':'$575';
      }
    }
    root.addEventListener('change',function(){queueMicrotask(sync)});
    root.addEventListener('input',function(){queueMicrotask(sync)});
    root.addEventListener('click',function(){queueMicrotask(sync)});
    function submit(event){
      event.preventDefault();event.stopImmediatePropagation();
      sync();if(button.disabled||!form.reportValidity())return;
      var data=new FormData(form),items=null;
      if(cup){
        var flavour=root.querySelector('input[name="cupcake-flavour"]:checked')?.value||'Vanilla';
        var variant=options.find(function(o){return /^12\b/.test(o.textContent)&&(/Mud/.test(flavour)?o.textContent.includes(' — '+flavour+' — $'):!o.textContent.includes('Mud'))});
        if(!variant){alert('The selected flavour is temporarily unavailable. Please try again.');return}
        data.set('id',variant.value);data.set('quantity',document.getElementById('cupcake-form-boxes').value);
        data.set('properties[Flavour]',flavour);
      }else if(platter){
        var add=root.querySelector('input[name="extra-topper"]:checked')?.value==='add';
        var variant=options.find(function(o){return add?o.textContent.includes(' — Personalised topper'):!o.textContent.includes(' — Personalised topper')});
        if(!variant){alert('The selected option is temporarily unavailable. Please try again.');return}
        data.set('id',variant.value);
      }else{
        var boxes=Number(document.getElementById('extra-box-count')?.textContent||1);
        if(boxes>2){
          var props={};data.forEach(function(value,key){var match=key.match(/^properties\[(.*)\]$/);if(match&&typeof value==='string')props[match[1]]=value});
          props['Boxes of 12']=String(boxes);items=[];
          var v24=options.find(function(o){return /^24\b/.test(o.textContent)}),v12=options.find(function(o){return /^12\b/.test(o.textContent)});
          if(Math.floor(boxes/2))items.push({id:Number(v24.value),quantity:Math.floor(boxes/2),properties:props});
          if(boxes%2)items.push({id:Number(v12.value),quantity:1,properties:props});
        }
      }
      button.disabled=true;
      fetch('/cart/add.js',{method:'POST',body:items?JSON.stringify({items:items}):data,headers:items?{'Content-Type':'application/json',Accept:'application/json'}:{Accept:'application/json'}})
        .then(async function(response){var result=await response.json();if(!response.ok)throw new Error(result.description||'Cart add failed');window.location.assign('/cart')})
        .catch(function(error){button.disabled=false;alert(error.message)});
    }
    button.addEventListener('click',submit,true);
    form.addEventListener('submit',submit,true);
    sync();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
